module.exports = __webpack_public_path__ + "static/media/sim-card-android-mweb.dfc60521.webp";